import React from 'react';
export default function Underline(props) {
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement("u", props.dataAttributes, props.children);
}